import { lazy } from "react"
import { IStaking } from "store/apis/stakingAPI/types"
import { CURRENCY } from "store/apis/balanceAPI/values"

export const STAKING_MODALS = {
  stakingSummaryNew: {}, // TODO: add component
  stakingSummaryOld: {}, // TODO: add component
  initWithdrawal: {}, // TODO: add component
  disconnectWallet: {
    component: lazy(() => import("modals/ui/staking/DisconnectWallet"))
  },
  confirmWithdraw: {
    component: lazy(() => import("modals/ui/staking/ConfirmWithdraw")),
    params: {} as {
      coin: CURRENCY
      amount: number
      onConfirm: () => void
    }
  },
  confirmCancelWithdraw: {
    component: lazy(() => import("modals/ui/staking/ConfirmCancelWithdrawal")),
    params: {} as {
      coin: CURRENCY
      amount: number | string
      wallet: string
      createDate: Date
      transactionId: string
      convertAmount: number
      showErrorSnuck: () => void
      showSuccessSnuck: () => void
    }
  },
  closeCompleteStaking: {},
  cancelStaking: {},
  stakingFinished: {
    component: lazy(() => import("modals/ui/staking/staking-finished")),
    params: {} as {
      income: number
      stakings: IStaking[]
    }
  },
  stakerInfo: {
    component: lazy(() => import("modals/ui/staking/staker-info"))
  }
} as const
